import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//specifique import
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
import i18n from './i18n'; // Import the i18n configuration
import { BootstrapVue3 } from 'bootstrap-vue-3';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';
import { CIcon } from '@coreui/icons-vue';
import CoreuiVue from '@coreui/vue';
import { TrackingService } from '@/api'
import '@/assets/globalStyle.css'



const app = createApp(App);
app.use(store);
app.use(router);
app.use(i18n);
app.use(CoreuiVue);
//app.component("AlertMe", AlertMe); // Add GlobalAlert as a global component
app.use(BootstrapVue3);
app.component('CIcon', CIcon);

        // 🔥 Track Menu Navigation
        /*router.afterEach((to, from) => {
            TrackingService.trackAction("Navigation", {
            page: to.path, // Current Page
            fromPage: from.path, // Previous Page
            });
        });*/

        console.log("API URL:", process.env.VUE_APP_API_URL);
        console.log("App Name:", process.env.VUE_APP_APP_NAME);
        console.log("Mode:", process.env.VUE_APP_MODE);
  
      // Global Event Listener for Buttons
      document.addEventListener("click", (event) => {
        if (event.target.tagName === "BUTTON") {
          const actionName = event.target.innerText.trim(); // Button text
          const buttonId = event.target.id || "no-id"; // Button ID (if exists)
          const page = router.currentRoute.value.path; // Get current page URL
          if(buttonId !== 'ignore'){
            TrackingService.trackAction(actionName, { page, buttonId });
          }
          
        }
      });


app.mount('#app')
